module.exports = __webpack_public_path__ + "static/media/broken_invitation_code.cbc8724a.svg";